import SectionFirstPage from '@/components/common/SectionFirstPage';
import SectionAboutUs from '@/components/pages/CompanyInformation/SectionAboutUs';
import SectionCoreValue from '@/components/pages/CompanyInformation/SectionCoreValue';
import SectionHistory from '@/components/pages/CompanyInformation/SectionHistory';
import SectionMission from '@/components/pages/CompanyInformation/SectionMission';
import SectionVision from '@/components/pages/CompanyInformation/SectionVision';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CompanyInformation = () => {
  const { t } = useTranslation();
  return (
    <div>
      <SectionFirstPage
        title={
          <h1>
            {t('Company')}
            <br />
            <span>{t('Information')}</span>
          </h1>
        }
        desc={t('Warppipe: Creating the Future of Business Together Through Innovative Technology')}
      />
      <SectionAboutUs />
      <SectionVision />
      <SectionMission />
      <SectionCoreValue />
      <SectionHistory />
    </div>
  );
};

export default React.memo(CompanyInformation);
